import { cn } from "@/lib/utils";

/** Símbolo Fornada: pizza em pizza-chart com a fatia superior direita destacada. */
export function Symbol({
  size = 28,
  className,
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      role="img"
      aria-label="Fornada"
      className={cn("shrink-0", className)}
    >
      <rect width="48" height="48" rx="13" fill="#C8323F" />
      <path d="M24 25 L35.26 18.5 A13 13 0 1 1 24 12 Z" fill="#F2E3C6" />
      <path d="M26 22 L26 9 A13 13 0 0 1 37.26 15.5 Z" fill="#F2E3C6" />
    </svg>
  );
}

export function Wordmark({
  size = 28,
  className,
}: {
  size?: number;
  className?: string;
}) {
  return (
    <span className={cn("flex items-center gap-2.5", className)}>
      <Symbol size={size} />
      <span
        className="fx-display"
        style={{ fontSize: Math.round(size * 0.72), letterSpacing: "-0.025em", lineHeight: 1 }}
      >
        FORNADA
      </span>
    </span>
  );
}

export function Avatar({
  initials,
  size = 36,
  className,
}: {
  initials: string;
  size?: number;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full border border-fx-line bg-fx-raised font-bold text-fx-cream",
        className,
      )}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.36) }}
      aria-hidden
    >
      {initials}
    </span>
  );
}
